<template>
  <div>
    <headerNav title="销售业绩明细" />
    <!-- <van-calendar v-model="show" :min-date="minDate" type="range" @confirm="onConfirm"/>
    <van-sticky>
      <van-cell title="选择订单时间" :value="date" @click="show = true" />
    </van-sticky> -->
    <div>
      <van-list
        v-model="loaded"
        :finished="loadingType == 'nomore' ? true : false"
        :finished-text="loadingType == 'nomore' ? '没有更多了' : '下拉加载更多'"
        @load="loadData"
      >
        <div v-for="(item, index) in list" class="mian-list" :key="index">
          <div class="mian-list-info">
            <div class="mian-list-info-data">
              <span>增加业绩:{{ item.money }}</span>

            </div>
            <div class="mian-list-info-data">
              <span>备注:</span>
              <span>{{ item.comment }}</span>
            </div>
            <div class="mian-list-info-data-last">
              {{ item.creationTime }}
            </div>
          </div>

          <!-- <div class="mian-list-mark" v-if="item.comment">
                              <div>备注:{{item.comment}}</div>
                          </div> -->
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      date: "",
      sticky: true,
      popshow: false,
      show: false,
      minDate: new Date(2020, 0, 1),
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      loadingType: "more",
      loaded: false,
      getparams: {
        maxResultCount: 8,
        skipCount: 0,
      },
      totalCount: 0,
      starttime: undefined,
      endtime: undefined,
      iptvalue: undefined,
    };
  },
  created() {},
  methods: {
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onclose() {
      this.sticky = true;
    },
    onConfirm(date) {
      this.sticky = false;
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;

      this.starttime = start;
      this.endtime = end;
      this.navList.forEach((x) => {
        x.loadingType = "refresh";
      });
      this.loadData();
      //将数组重置 并重新执行查询

      //startTime
      //endTime
    },
    onSearch(val) {
      //将数组重置 并重新执行查询
      console.log(val);
      this.iptvalue = val;
      this.loadData();
    },
    onRefresh() {
      this.loadData("refresh");
    },
    loadData(source) {
      if (this.loadingType === "loading" || this.loadingType === "nomore") {
        //防止重复加载
        if (source != "refresh") {
          return;
        }
      }

      if (source == "refresh" || this.loadingType == "refresh") {
        this.list = [];
        this.getparams.skipCount = 0;
        this.getparams.startTime = this.starttime;
        this.getparams.endtime = this.endtime;
        this.getparams.tid = this.iptvalue;
      }

      this.loadingType = "loading";
      var params = this.getparams;
      //加载数据
      this.ajax
        .post("/api/services/app/PhoneMemberTeamPerformanceRecord/QueryModelList", params)
        .then((x) => {
          this.getparams.skipCount += this.getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.list = this.list.concat(x.result.items);
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
          this.loadingType = totalcount > this.getparams.skipCount ? "more" : "nomore";
        })
        .finally(() => {
          this.loaded = false;
          this.refreshing = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mian-list {
  background-color: #fff;
  margin-top: 10px;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px;
  padding: 10px;
  box-shadow: 1px 1px 4px #c3c3c3;
  word-break: break-all;
  line-height: 20px;
}
.mian-list-info {
  padding: 5px 0 5px 0px;
  font-size: 14px;
  position: relative;
  word-break: break-all;
}
.mian-list-info-right {
  position: absolute;
  right: 0;
  width: 90px;
  text-align: right;
}
.mian-list-info-right-tag {
  position: absolute;
  right: 0;
}
.mian-list-mark {
  border-top: 1px solid #e2e2e2;
  padding-top: 10px;
  font-size: 18px;
}
.mian-list-btns {
  margin-top: 20px;
  text-align: center;
}
.mian-list-btns button {
  margin-right: 10px;
  padding: 8px 20px;
  height: auto;
  border-radius: 34px;
  border: 0;
}
.mian-list-pic {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100px;
  height: 100px;
  transform: translate(0, -50%);
}
.mian-list-pic img {
  width: 100%;
  height: 100%;
}
.info {
  position: relative;
  background-color: #fff;
  border-radius: 8px;
  margin: 20px 10px 10px 10px;
  font-size: 12px;
  width: 250px;
}
.mz-proof-btns {
  margin-bottom: 10px;
  text-align: center;
}
.mz-proof-btns button {
  margin-right: 10px;
  padding: 8px 20px;
  height: auto;
  border-radius: 34px;
  border: 0;
}
.mian-list-info-data-last {
  text-align: right;
}
</style>
<style lang="scss" scoped>
.van-uploader__wrapper {
  width: 100%;
  display: block;
}

.van-uploader__upload {
  width: 100%;
}
.van-uploader {
  display: block;
}
.van-uploader__preview-image {
  width: 100%;
  height: 80px;
}
</style>
